class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);

class CartDrawerAddRecommendedButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      let id = Number(
        $(this).parent().find(".upgrade-swatch.selectedColor").data("varid")
      );
      const sectionsToRender = [
        {
          id: "cart-drawer__content",
          section: document.getElementById("cart-drawer__content").dataset.id,
          selector: ".cart-drawer__content",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];

      const body = JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1,
          },
        ],
        sections: sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname,
      });

      document
        .querySelector(".discount-announcements-heading")
        ?.classList.add("hidden");
      document
        .querySelector(".discount-announcements-heading-discount-applied")
        ?.classList.add("hidden");
      document
        .querySelector(".discount-announcements-heading-updating-discounts")
        ?.classList.remove("hidden");

      fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
        .then((response) => response.json())
        .then((parsedState) => {
          sectionsToRender.forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.querySelector("cart-drawer").open();
          typeof window.updateDiscountAnnouncements === "function" &&
            window.updateDiscountAnnouncements();
          window.updateFreeShippingBar();
        });
      this.closest("cart-drawer").createRecommendedProductsList();
    });
  }
}

customElements.define(
  "cart-drawer-add-recommended-button",
  CartDrawerAddRecommendedButton
);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById("cart-drawer");
    this.cartButton = document.querySelector(".js-open-cart");
    this.cartButton.addEventListener("click", this.handleCartClick.bind(this));
    this.closeIcon = document.getElementById("cart-drawer__close");
    this.closeIcon.addEventListener("click", this.close.bind(this));
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.pageOverlayElement = document.querySelector(".page-overlay");

    // Functionality
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    document.querySelector("cart-drawer").createRecommendedProductsList();

    this.addIgEvent();
  }

  async addIgEvent() {
    window.addEventListener("ig:CartUpdated", async () => {
      this.enableLoading();

      try {
        const response = await fetch(`${routes.cart_get}`, {
          ...fetchConfig(),
        });
        const state = await response.text();
        const parsedState = JSON.parse(state);

        const sectionsResponse = await fetch(
          `${routes.cart_url}?sections=${this.getSectionsToRender().map(
            (section) => section.section
          )}`
        );
        parsedState.sections = await sectionsResponse.json();

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        await this.createRecommendedProductsList();
      } catch (error) {
        console.error("Error occurred:", error);
      } finally {
        this.disableLoading();
        typeof window.updateDiscountAnnouncements === "function" &&
          window.updateDiscountAnnouncements();
      }
    });
  }

  open() {
    this.drawer.setAttribute("aria-hidden", false);
    this.drawer.setAttribute("aria-expanded", true);

    this.pageOverlayElement?.classList.add("is-visible");

    if (document.querySelector(".fly-out-cards")?.childElementCount !== 0) {
      document
        .querySelector(".fly-out-cards-container")
        ?.classList.remove("hidden");
    }

    document.body.classList.add("is-overlayed");
    document.body.addEventListener("click", this.onBodyClick);
    this.createRecommendedProductsList();
    function waitForElement(selector, callback) {
      if (document.querySelector(selector) !== null) {
        callback();
      } else {
        setTimeout(function () {
          waitForElement(selector, callback);
        }, 100);
      }
    }

    waitForElement(".cart-drawer #dcodeInfo", function () {
      var dcodeOuterWrapperHeight =
        $(".cart-drawer #dcodeInnerWrapper").outerHeight(true) + 70;
      $(".cart-drawer .cart-drawer__content").css({
        "height": "calc(100% - " + dcodeOuterWrapperHeight + "px)",
        "touch-action": "pan-y",
        "-webkit-overflow-scrolling": "touch"
      });
    });
  }

  close() {
    this.drawer.setAttribute("aria-hidden", true);
    this.drawer.removeAttribute("aria-expanded", true);

    this.pageOverlayElement?.classList.remove("is-visible");
    this.pageOverlayElement
      ?.querySelector(".fly-out-cards-container")
      ?.classList.add("hidden");
    document.body.classList.remove("is-overlayed");

    document.body.removeEventListener("click", this.onBodyClick);
  }

  changeSelectedVariant(event) {
    const recommendedProductIndex = event.target.dataset.recommendedProduct;
    const variantSelectedIndex = event.target.dataset.variant;
    const t = event.target.dataset.type;
    for (let v = 0; v <= 5; v++) {
      const elementProductRecommendedImage = document.getElementById(
        `cart-drawer-product-recommended-${recommendedProductIndex}-image-${v}${t}`
      );
      const elementProductRecommendedVariantTitle = document.getElementById(
        `cart-drawer-product-recommended-${recommendedProductIndex}-variant-title${t}`
      );
      const elementProductRecommendedVariantInput = document.getElementById(
        `cart-drawer-product-recommended-${recommendedProductIndex}-variant-input-${v}${t}`
      );
      const elementProductRecommendedVariant = document.getElementById(
        `cart-drawer-product-recommended-${recommendedProductIndex}-variant-${v}${t}`
      );
      if (v === Number(variantSelectedIndex)) {
        if (elementProductRecommendedImage) {
          elementProductRecommendedImage.style.display = "block";
        }
        if (elementProductRecommendedVariantInput) {
          elementProductRecommendedVariantInput.checked = true;
        }
        if (elementProductRecommendedVariantTitle) {
          elementProductRecommendedVariantTitle.innerHTML =
            event.target.innerHTML;
        }
        if (elementProductRecommendedVariant) {
          elementProductRecommendedVariant.classList.add("selectedColor");
        }
      } else {
        if (elementProductRecommendedImage) {
          elementProductRecommendedImage.style.display = "none";
        }
        if (elementProductRecommendedVariantInput) {
          elementProductRecommendedVariantInput.checked = false;
        }
        if (elementProductRecommendedVariant) {
          elementProductRecommendedVariant.classList.remove("selectedColor");
        }
      }
    }
  }

  getOrderedRecommendedsProductsList() {
    const cardItems = document.getElementsByClassName("cart-drawer__item");
    const itemsQuantity = document.getElementById("cart-drawer__counter");
    let totalQuantity = 0;
    for (let item of cardItems) {
      totalQuantity += Number(item.dataset.productQuantity);
    }
    if (totalQuantity != 0) {
      itemsQuantity.innerHTML = `(${totalQuantity} ${
        totalQuantity == 1 ? "Item)" : "Items)"
      }`;
    } else {
      itemsQuantity.innerHTML = "(0 items)";
    }
    let recommendedsProducts = {};
    for (let item of cardItems) {
      totalQuantity += Number(item.dataset.productQuantity);
      for (let i = 1; i <= 3; i++) {
        if (item.dataset[`recommendedProduct-${i}`]) {
          const recommendedProduct = JSON.parse(
            item.dataset[`recommendedProduct-${i}`]
          );
          if (recommendedProduct.product) {
            if (recommendedsProducts[recommendedProduct.product.id]) {
              recommendedsProducts[recommendedProduct.product.id].quantity += 1;
            } else {
              recommendedsProducts[recommendedProduct.product.id] = {
                ...recommendedProduct.product,
                variants: Array.from(
                  recommendedProduct.product.variants || [],
                  (variant) => ({
                    ...variant,
                    variantImage: recommendedProduct[variant.id],
                  })
                ),
                quantity: 1,
              };
            }
          }
        }
      }
    }
    for (let item of cardItems) {
      if (recommendedsProducts[item.dataset.productId]) {
        delete recommendedsProducts[item.dataset.productId];
      }
    }
    const orderedRecommendedsProducts = Object.values(
      recommendedsProducts
    ).sort((a, b) => b.quantity - a.quantity);
    return orderedRecommendedsProducts;
  }

  setVariant(i, v, t, variant) {
    const elementProductRecommendedImage = document.getElementById(
      `cart-drawer-product-recommended-${i}-image-${v}${t}`
    );
    const elementProductRecommendedVariant = document.getElementById(
      `cart-drawer-product-recommended-${i}-variant-${v}${t}`
    );
    const elementProductRecommendedVariantTitle = document.getElementById(
      `cart-drawer-product-recommended-${i}-variant-title${t}`
    );

    const elementProductRecommendedVariantInput = document.getElementById(
      `cart-drawer-product-recommended-${i}-variant-input-${v}${t}`
    );
    if (v === 0) {
      if (elementProductRecommendedVariantTitle) {
        elementProductRecommendedVariantTitle.innerHTML = variant.title;
      }
      if (elementProductRecommendedVariantInput) {
        elementProductRecommendedVariantInput.checked = true;
      }
      if (elementProductRecommendedVariant) {
        elementProductRecommendedVariant.classList.add("selectedColor");
      }
      if (elementProductRecommendedImage) {
        elementProductRecommendedImage.style.display = "block";
      }
    }
    if (elementProductRecommendedImage) {
      elementProductRecommendedImage.src = variant.featured_image.src;
    }
    if (elementProductRecommendedVariant) {
      elementProductRecommendedVariant.style.display = "inline";
      elementProductRecommendedVariant.style.backgroundImage = `url('${variant.variantImage}')`;
      elementProductRecommendedVariant.innerHTML = variant.title;
      elementProductRecommendedVariant.onclick = this.changeSelectedVariant;
      elementProductRecommendedVariant.dataset.recommendedProduct = i;
      elementProductRecommendedVariant.dataset.variant = v;
      elementProductRecommendedVariant.dataset.varid = variant.id;
    }
    if (elementProductRecommendedVariantInput) {
      elementProductRecommendedVariantInput.style.display = "block";
    }
  }
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }

  createRecommendedProductsList() {
    let productData = this.getOrderedRecommendedsProductsList();
    for (let i = 0; i <= 3; i++) {
      if (productData[i]) {
        for (let t = 0; t <= 1; t++) {
          const elementProductRecommended = document.getElementById(
            `cart-drawer-product-recommended-${i}${t}`
          );
          const elementProductRecommendedTitle = document.getElementById(
            `cart-drawer-product-recommended-${i}-title${t}`
          );
          const elementProductRecommendedPrice = document.getElementById(
            `cart-drawer-product-recommended-${i}-price${t}`
          );
          const productPrice = productData[i]?.price?.toString().slice(0, -2);
          for (let v = 0; v <= 5; v++) {
            if (productData[i].variants[v]) {
              this.setVariant(i, v, t, productData[i].variants[v]);
            }
          }
          if (elementProductRecommended) {
            elementProductRecommended.style.display = "flex";
          }
          if (elementProductRecommendedTitle) {
            elementProductRecommendedTitle.text = productData[i].title;
            elementProductRecommendedTitle.href = productData[i].href;
          }
          if (elementProductRecommendedPrice) {
            elementProductRecommendedPrice.innerHTML = `$${productPrice?.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            )}`;
            elementProductRecommendedPrice.setAttribute(
              "data-product-id",
              productData[i].id
            );
          }
        }
      }
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document
      .querySelector(".discount-announcements-heading")
      ?.classList.add("hidden");
    document
      .querySelector(".discount-announcements-heading-discount-applied")
      ?.classList.add("hidden");
    document
      .querySelector(".discount-announcements-heading-updating-discounts")
      ?.classList.remove("hidden");

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        window.flyOutLoad.call(this);
        this.createRecommendedProductsList()
          .then(() => {
            this.disableLoading();
          })
          .catch(() => {
            this.disableLoading();
          });
      })
      .catch(() => {
        this.disableLoading();
      })
      .finally(() => {
        typeof window.updateDiscountAnnouncements === "function" &&
          window.updateDiscountAnnouncements();
        typeof window.updateFreeShippingBar === "function" &&
          window.updateFreeShippingBar();
        typeof window.variantOptionChangeDrawer === "function" &&
          window.variantOptionChangeDrawer();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer__content",
        section: document.getElementById("cart-drawer__content").dataset.id,
        selector: ".cart-drawer__content",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById("cart-drawer-loading").classList.remove("hidden");
  }

  disableLoading() {
    document.getElementById("cart-drawer-loading")?.classList.add("hidden");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      !document.querySelector(".js-open-cart") &&
      !target.closest("cart-drawer")
    ) {
      this.close();
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define("cart-drawer", CartDrawer);
